import { IVariableScopeDictionary } from "../actions/VariableScopeAnalyzer";

export enum ValidationErrorType {
    NoIncomingSequences,
    NoOutgoingSequences,
    ExclusiveGatewayOutgoingMissing,
    NoProcessName,
    InvalidKeyName,
    NoElementName,
    DuplicateName,
    TaskSelectionMissing,
    TriggerSelectionMissing,
    SubprocessSelectionMissing,
    VariableNameMissing,
    DuplicateVariableName,
    InvalidReference,
    DuplicateApiTrigger,
    LoopsAreNotAllowed,
    OnlyOneIncomingConnection,
    IntermediateReturnCannotBeOnlyConnection,
    TriggersMustPointToSameTarget,
    IncompatibleTask,
    InvalidVariableName,
    MissingValue,
    InvalidProcessVariableValue,
    InvalidProcessVariableValueText,
    InvalidProcessVariableValueToggle,
    InvalidProcessVariableValueInteger,
    HttpTriggerMissingUrl,
    ProcessVariablesInTriggersNotAllowed
}

export interface ValidationState {
    elementIdsToValidate: string[];
    validationDictionary: ValidationErrorDictionary;
    variableScopeDictionary: IVariableScopeDictionary;
}

export interface ValidationErrorDictionary {
    [elementId: string]: ValidationError[];
}

export class ValidationError {
    public elementId: string | undefined;
    public messageType: ValidationErrorType | null;
    public parameterKey: string | undefined;
    public referenceValue: string | undefined;
    public messageString: string | undefined;
    constructor(messageType: ValidationErrorType | null, id?: string, parameterKey?: string | null, referenceValue?: string, messageString?: string) {
        this.messageType = messageType;
        this.elementId = id || undefined;
        this.parameterKey = parameterKey || undefined;
        this.referenceValue = referenceValue || undefined;
        this.messageString = messageString || undefined;
    }

    public getMessageString(): string {
        if (this.messageString) {
            return this.messageString;
        }

        let message: string;
        switch (this.messageType) {
            case ValidationErrorType.NoProcessName:
                message = FRENDS.Localizations.ProcessHasNoName;
                break;
            case ValidationErrorType.InvalidKeyName:
                message = FRENDS.Localizations.Validation_InvalidKeyName;
                break;
            case ValidationErrorType.NoIncomingSequences:
                message = FRENDS.Localizations.Validation_ErrorNoIncomingSequences;
                break;
            case ValidationErrorType.NoOutgoingSequences:
                message = FRENDS.Localizations.Validation_ErrorNoOutgoingSequences;
                break;
            case ValidationErrorType.ExclusiveGatewayOutgoingMissing:
                message = FRENDS.Localizations.Validation_ExclusiveGatewayMissingOutgoing;
                break;
            case ValidationErrorType.NoElementName:
                message = FRENDS.Localizations.Missing + " " + FRENDS.Localizations.Name.toLowerCase();
                break;
            case ValidationErrorType.DuplicateName:
                message = FRENDS.Localizations.Validation_ElementsMustHaveUniqueNames;
                break;
            case ValidationErrorType.TaskSelectionMissing:
                message = FRENDS.Localizations.Validation_NoTaskType;
                break;
            case ValidationErrorType.TriggerSelectionMissing:
                message = FRENDS.Localizations.Validation_NoTriggerType;
                break;
            case ValidationErrorType.SubprocessSelectionMissing:
                message = FRENDS.Localizations.Validation_NoSubprocessType;
                break;
            case ValidationErrorType.VariableNameMissing:
                message = FRENDS.Localizations.Validation_VariableNameMissing;
                break;
            case ValidationErrorType.DuplicateVariableName:
                message = FRENDS.Localizations.Validation_VariableAlreadyDeclared;
                break;
            case ValidationErrorType.InvalidReference:
                message = this.referenceValue + " " + FRENDS.Localizations.Validation_InvalidReference.toLowerCase();
                break;
            case ValidationErrorType.DuplicateApiTrigger:
                message = FRENDS.Localizations.Validation_OnlyOneAPITriggerAllowed;
                break;
            case ValidationErrorType.LoopsAreNotAllowed:
                message = FRENDS.Localizations.Validation_LoopsNotAllowed;
                break;
            case ValidationErrorType.OnlyOneIncomingConnection:
                message = FRENDS.Localizations.Validation_OnlyOneIncoming;
                break;
            case ValidationErrorType.IntermediateReturnCannotBeOnlyConnection:
                message = FRENDS.Localizations.Validation_IntermediateReturnCannotBeOnlyConnection;
                break;
            case ValidationErrorType.TriggersMustPointToSameTarget:
                message = FRENDS.Localizations.Validation_TriggersMustPointToSameTarget;
                break;
            case ValidationErrorType.IncompatibleTask:
                message = FRENDS.Localizations.Task_NotCompatibleFramework;
                break;
            case ValidationErrorType.MissingValue:
                message = "Value cannot be empty";
                break;
            case ValidationErrorType.InvalidProcessVariableValue:
                message = "Value must be either an environment variable or JSON-parsable.";
                break;
            case ValidationErrorType.InvalidProcessVariableValueText:
                message = 'Value must be JSON-parsable string, or an environment variable.';
                break;
            case ValidationErrorType.InvalidProcessVariableValueToggle:
                message = "Value must be either true or false, or an environment variable.";
                break;
            case ValidationErrorType.InvalidProcessVariableValueInteger:
                message = "Value must be either a number or an environment variable.";
                break;
            case ValidationErrorType.HttpTriggerMissingUrl:
                message = "HTTP Trigger must have a URL."
                break;
            case ValidationErrorType.ProcessVariablesInTriggersNotAllowed:
                message = "Process variables cannot be used in triggers";
                break;
            default:
                message = FRENDS.Localizations.Unknown;
                break;
        }
        return message;
    }
}
